<template>
  <div>
    <app-header></app-header>
    <router-view />
  </div>
</template>

<script>
import Header from "./Header";
export default {
  components: {
    appHeader: Header,
  },
  data: () => ({
    message: "MainLayout.vue",
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/layout/IntroLayout.vue